function withSearchParams(Component) {
    return function WrappedComponent(props) {
        const searchParams = new URLSearchParams(window.location.search);
        return <Component {...props} searchParams={searchParams} />;
    };
}

export default withSearchParams;
